import { BalanceSheetMonthlyData } from '@/types/balance-sheet-monthly.api';
import BalanceSheetChart from './graph/BalanceSheetBarChart';
import LoadingPage from '../LoadingPage';

interface BalanceSheetGraphProps { data: BalanceSheetMonthlyData }

const BalanceSheetGraph = (data: BalanceSheetGraphProps) => {
    if (!data.data) return <LoadingPage />;

    return (<BalanceSheetChart data={data.data} />);
};

export default BalanceSheetGraph;